import React from 'react';
import './hero-banner.scss';

export interface HeroBannerProps {
    title?: string;
    subtitle?: string;
    children?: React.ReactNode;
    variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
    size?: 'small' | 'medium' | 'large' | 'fullheight';
    className?: string;
    backgroundImage?: string;
    overlay?: boolean;
}

export const HeroBanner: React.FC<HeroBannerProps> = ({
    title,
    subtitle,
    children,
    variant = 'primary',
    size = 'medium',
    className = '',
    backgroundImage,
    overlay = false
}) => {
    const getVariantClasses = () => {
        const variantMap = {
            primary: 'bg-primary text-white',
            secondary: 'bg-secondary text-white',
            success: 'bg-success text-white',
            danger: 'bg-danger text-white',
            warning: 'bg-warning text-dark',
            info: 'bg-info text-white',
            light: 'bg-light text-dark',
            dark: 'bg-dark text-white'
        };
        return variantMap[variant] || variantMap.primary;
    };

    const getSizeClasses = () => {
        const sizeMap = {
            small: 'py-4',
            medium: 'py-5',
            large: 'py-5',
            fullheight: 'min-vh-100 d-flex align-items-center'
        };
        return sizeMap[size] || sizeMap.medium;
    };

    const containerClasses = `hero-banner ${getVariantClasses()} ${getSizeClasses()} ${className}`;
    const backgroundStyle = backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {};

    return (
        <section 
            className={containerClasses}
            style={backgroundStyle}
        >
            {overlay && backgroundImage && (
                <div className="hero-overlay"></div>
            )}
            <div className="hero-body">
                <div className="container">
                    {title && (
                        <h1 className="hero-title display-4 fw-bold mb-3">
                            {title}
                        </h1>
                    )}
                    {subtitle && (
                        <p className="hero-subtitle lead mb-4">
                            {subtitle}
                        </p>
                    )}
                    {children}
                </div>
            </div>
        </section>
    );
};

export default HeroBanner; 